export const LogLevel = {
    None: 0,
    Critical: 1,
    Error: 2,
    Warning: 3,
    Info: 4,
    Debug: 5,
    Trace: 6,
};
export const LogLevelNames = {
    [LogLevel.None]: 'None',
    [LogLevel.Critical]: 'Critical',
    [LogLevel.Error]: 'Error',
    [LogLevel.Warning]: 'Warning',
    [LogLevel.Info]: 'Info',
    [LogLevel.Debug]: 'Debug',
    [LogLevel.Trace]: 'Trace',
};
export function isLogLevelName(l) {
    return LogLevel.hasOwnProperty(l);
}
export class Logger {
    constructor(name, outputLevel = LogLevel.Info) {
        this.name = name;
        this.outputLevel = outputLevel;
    }
    setOutputLogLevel(outputLevel) {
        this.outputLevel = outputLevel;
    }
    log(level, message, ...data) {
        if (level > this.outputLevel)
            return;
        const consoleMethodMapping = {
            [LogLevel.Critical]: 'error',
            [LogLevel.Error]: 'error',
            [LogLevel.Warning]: 'warn',
            [LogLevel.Info]: 'info',
            [LogLevel.Debug]: 'debug',
            [LogLevel.Trace]: 'debug',
        };
        const levelName = LogLevelNames[level];
        const timestamp = new Date().toISOString();
        const browserLog = console[consoleMethodMapping[level]].bind(console);
        browserLog(`[${this.name}] ${timestamp} ${levelName}: ${message}`, ...data);
    }
    trace(message, ...data) {
        this.log(LogLevel.Trace, message, ...data);
    }
    debug(message, ...data) {
        this.log(LogLevel.Debug, message, ...data);
    }
    info(message, ...data) {
        this.log(LogLevel.Info, message, ...data);
    }
    warn(message, ...data) {
        this.log(LogLevel.Warning, message, ...data);
    }
    error(message, ...data) {
        this.log(LogLevel.Error, message, ...data);
    }
    critical(message, ...data) {
        this.log(LogLevel.Critical, message, ...data);
    }
}
